export const CUSTOMER_PORTAL_USER_ROLE = "customer:user";
export const CUSTOMER_PORTAL_ADMIN_ROLE = "customer:admin";
export const VENDOR_ADMIN_ROLE = "vendor:admin";
